module.exports = __webpack_public_path__ + "img/solidworks.8805eca9.svg";